import React, { useEffect, useMemo, useState } from 'react';
import AccountSelect, {
  IAccountOption,
} from 'components/AccountSelect/AccountSelect';
import styles from './AccountDetails.module.scss';

interface IDetail {
  label: string;
  value: string;
}

type Props = {
  Model?: any;
  PageData?: any;
  LayoutModel?: any;
};

const Detail = ({ label, value }: IDetail) => (
  <div className={styles.detail}>
    <div className={styles.label}>{label}</div>
    <div className={styles.value}>{value}</div>
  </div>
);

const AccountDetails = ({ Model, PageData }: Props) => {
  const [currentAccount, setCurrentAccount] = useState<any>(null);
  const accounts = Model?.DebtOverviewCollection || [];
  const accountsList: IAccountOption[] = useMemo(() => {
    return accounts.map((acc: any) => ({
      value: acc.CaseReference,
      reference: acc.CaseReference,
      balance: acc.FormattedOriginalBalance,
    }));
  }, [accounts]);

  useEffect(() => {
    if (accounts.length > 1) {
      const [firstAcc] = accounts;
      setCurrentAccount(firstAcc.CaseReference);
    }
  }, [accounts]);

  if (Model?.HasAnyDebtOverview) {
    return (
      <div className={styles.container}>
        {!Model?.IsRolledUpAccount ? (
          <div className={styles.wrapper}>
            <header className={styles.header}>
              <Detail
                label={PageData?.OriginalLenderName}
                value={Model?.DebtOverview?.OriginalLenderName}
              />
            </header>
            <div className={styles.row}>
              <Detail
                label={PageData?.DebtReferenceLabel}
                value={Model?.DebtReference}
              />
              <Detail
                label={PageData?.OriginalLenderReference}
                value={Model?.DebtOverview?.OriginalLenderReference}
              />
              <Detail
                label={PageData?.CaseReferenceLabel}
                value={Model?.DebtOverview?.CaseReference}
              />
              <Detail
                label={PageData?.OriginalBalanceLabel}
                value={Model?.DebtOverview?.FormattedOriginalBalance}
              />
            </div>
          </div>
        ) : (
          <div className={styles.wrapper}>
            {(accountsList || []).length > 1 && (
              <div className={styles.select}>
                <AccountSelect
                  optionsList={accountsList}
                  selectedOption={currentAccount}
                  onChange={(acc: any) => setCurrentAccount(acc)}
                />
              </div>
            )}
            {(accounts || []).map(
              (account: any, index: number) =>
                account.CaseReference === currentAccount && (
                  <div key={index}>
                    <header className={styles.header}>
                      <Detail
                        label={PageData?.OriginalLenderName}
                        value={account?.OriginalLenderName}
                      />
                    </header>
                    <div className={styles.row}>
                      <Detail
                        label={PageData?.DebtReferenceLabel}
                        value={Model?.DebtReference}
                      />
                      <Detail
                        label={PageData?.OriginalLenderReference}
                        value={account?.OriginalLenderReference}
                      />
                      <Detail
                        label={PageData?.CaseReferenceLabel}
                        value={account?.CaseReference}
                      />
                      <Detail
                        label={PageData?.OriginalBalanceLabel}
                        value={account.FormattedOriginalBalance}
                      />
                    </div>
                  </div>
                ),
            )}
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default AccountDetails;
